<template>
    <div class="root">
      <div style="font-size: .4rem;width: 7.2rem;margin: .4rem auto">流量池预存</div>
      <div class="info-item">
        <div class="title">池名称</div>
        <div class="value">{{poolInfo.name}}</div>
      </div>
      <div class="info-item">
        <div class="title">总卡量</div>
        <div class="value">{{poolInfo.cardNum}}</div>
      </div>
      <div class="info-item">
        <div class="title">本月用量</div>
        <div class="value">{{poolInfo.totalUsage}}G</div>
      </div>
      <div class="info-item">
        <div class="title">剩余额度</div>
        <div class="value">{{poolInfo.remainBalance}}元</div>
      </div>
      <div class="info-item">
        <div class="title">日均消耗</div>
        <div class="value">{{poolInfo.avgPrice}}元</div>
      </div>
      <input placeholder="请输入预存金额" class="input" v-model="money" type="number"/>
      <div class="tips">请输入1000整数倍,如3000,5000...</div>
      <div class="paybtn" @click="pay">支付</div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                poolID:0,
              code:'',
              leshuaID:'',
              money:'',
              appid:'',
              poolInfo:{},
              openid:'',
            };
        },
        watch:{

        },
        methods: {
          pay(){
            this.$toast.loading({ forbidClick: true, duration:0})
            this.fetchData("/pool/createOrder",{id:this.poolID,money:this.money,openid:this.openid,appid:this.appid,leshuaID:this.leshuaID},res=>{
              this.$toast.clear();
              if(res.code){
                WeixinJSBridge.invoke(
                  "getBrandWCPayRequest", res.data,
                  (res) => {
                    if (res.err_msg == "get_brand_wcpay_request:ok") {
                      this.$toast("支付成功，请稍后刷新查看")
                      this.getPoolInfo()
                      this.money = ""
                    }
                  }
                )
              }else{
                this.$toast(res.msg)
              }
            })
          },
          getPoolInfo(){
            this.$toast.loading({ forbidClick: true, duration:0})
            this.fetchData("/pool/getPoolInfo",{id:this.poolID},res=>{
              this.$toast.clear();
              this.poolInfo = res.data
            })
          }
        },
        created: function () {
            this.poolID = this.$route.query.poolID;
            this.code = this.$route.query.code;
            this.appid = this.$route.query.appid;
            this.leshuaID = this.$route.query.leshuaID;
            if(!this.code){
              this.fetchData("/base/getAuthUrlByPool",{id:this.poolID,url:location.href,appid:this.appid,leshuaID:this.leshuaID},res=>{
                if(res.code){
                   // window.location.href = res.url
                }else{
                  this.$toast(res.msg)
                }
              })
            }else{
              this.code = this.$route.query.code;
              this.fetchData("/pool/getopenid",{code:this.code,appid:this.appid,leshuaID:this.leshuaID},res=>{
                this.$toast.clear();
                if(res.code){
                  this.openid = res.data;
                }else{
                  this.$toast(res.msg)
                }
              })
              this.getPoolInfo()
            }
        }
    };
</script>
<style lang="scss" scoped>
.root{
  width: 7.2rem;
  margin: 0 auto;
  .tips{
    text-align: left;
    width: 6rem;
    margin: 0 auto;
    font-size: .24rem;
    color: #ff2e2e;
  }
  .info-item{
    width: 6rem;
    margin: 0 auto;
    display: flex;
    line-height: .6rem;
    height: .6rem;
    border-bottom: 1px solid #eeeeee;
    .title{
      text-align: left;
      flex: 1;
      font-size: .24rem;
      color: #3f3f3f;
    }
    .value{
      text-align: right;
      flex: 1;
      font-size: .28rem;
      color: #333333;
    }
  }
  .input{
    width: 6rem;
    display: block;
    margin: 1rem auto 0;
    height: 40px;
    line-height: 40px;
    border: none;
    font-size: .32rem;
    font-weight: bold;
    border-bottom: 1px solid #999;
  }
  .paybtn{
    width: 6rem;
    margin: .4rem auto;
    height: 40px;
    line-height: 40px;
    color: #fff;
    background: #00a720;
    font-size: .28rem;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/poolRecharge.vue